import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { calculatePosition } from "../data/calculatePosition.js";
import { getArrows } from "../data/getArrows.js";
import { getBoxes } from "../data/getBoxes.js";
import { prepareTree } from "../data/prepareTree.js";
import { MarkerDef } from "./MarkerDef.js";
/**
 * Top-level component: prepare, lay out and draw the whole tree as one SVG,
 * sized to fit its content, with node boxes and the arrows connecting them.
 * @param props - The `tree` plus node, arrow and position option objects.
 * @returns The complete `<svg>` element.
 */
export function SVGBoxesTree(props) {
    const { tree, ...options } = props;
    const { arrowRendererOptions, nodeRendererOptions, positionOptions } = options;
    const data = prepareTree(tree, options);
    calculatePosition(data, positionOptions);
    const boxes = getBoxes(data, nodeRendererOptions);
    const arrows = getArrows(data, arrowRendererOptions);
    const svgSize = {
        width: 0,
        height: 0,
    };
    const width = [];
    for (const datum of data) {
        width.push(datum.childrenBoxSize.width);
        svgSize.height += datum.childrenBoxSize.height;
    }
    svgSize.width = Math.max(...width);
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: `0 0 ${svgSize.width} ${svgSize.height}`, children: [_jsx(MarkerDef, {}), boxes, arrows] }));
}
//# sourceMappingURL=SVGBoxesTree.js.map